import React, { useState, useEffect } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function History() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('semua');
  const [expandedId, setExpandedId] = useState(null);
  const [previewRecap, setPreviewRecap] = useState(null);

  useEffect(() => {
    api.get('/touring-events/history/with-my-status')
      .then((res) => setEvents(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  const displayEvents = filter === 'saya' ? events.filter((e) => e.my_ikut === true) : events;

  const tabStyle = (active) => ({
    background: active ? '#D02127' : 'transparent',
    color: active ? '#fff' : '#8B92A0',
    border: active ? 'none' : '1px solid #262b33',
    padding: '8px 18px',
    borderRadius: 6,
    fontSize: 13,
    fontWeight: 700,
    cursor: 'pointer',
  });

  if (loading) return <Layout><p style={{ color: '#8B92A0' }}>Memuat...</p></Layout>;

  return (
    <Layout>
      <h1 style={{ fontSize: 26, fontWeight: 900, fontStyle: 'italic', marginBottom: 20 }}>History Touring</h1>

      <div style={{ display: 'flex', gap: 10, marginBottom: 22 }}>
        <button onClick={() => setFilter('semua')} style={tabStyle(filter === 'semua')}>Semua</button>
        <button onClick={() => setFilter('saya')} style={tabStyle(filter === 'saya')}>Saya Ikut</button>
      </div>

      {displayEvents.length === 0 ? (
        <p style={{ color: '#8B92A0', fontSize: 14 }}>
          {filter === 'saya' ? 'Kamu belum pernah ikut touring apapun.' : 'Belum ada touring.'}
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {displayEvents.map((ev) => (
            <div
              key={ev.id}
              style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 16 }}
            >
              <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap' }}>
                {ev.status === 'ongoing' && (
                  <span style={{ background: 'rgba(208,33,39,0.2)', color: '#D02127', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 4 }}>
                    🔴 LIVE
                  </span>
                )}
                {ev.status === 'selesai' && (
                  <span style={{ background: 'rgba(74,222,128,0.15)', color: '#4ADE80', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 4 }}>
                    SELESAI
                  </span>
                )}
                <span style={{
                  background: ev.tipe === 'santai' ? 'rgba(139,146,160,0.2)' : 'rgba(43,105,150,0.2)',
                  color: ev.tipe === 'santai' ? '#8B92A0' : '#2B6996',
                  fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 4,
                }}>
                  {ev.tipe === 'santai' ? 'SANTAI' : 'RESMI'}
                </span>
                {ev.my_ikut === true && (
                  <span style={{ background: 'rgba(74,222,128,0.15)', color: '#4ADE80', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 4 }}>
                    ✓ SAYA IKUT
                  </span>
                )}
              </div>
              <p style={{ fontWeight: 800, fontSize: 15 }}>{ev.title}</p>
              {ev.location && <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 4 }}>📍 {ev.location}</p>}
              <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 4 }}>
                📅 {new Date(ev.tanggal_mulai).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}
              </p>
              <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 4 }}>
                👤 Dibuat oleh: {ev.creator_name}
              </p>
              <button
                onClick={() => setExpandedId(expandedId === ev.id ? null : ev.id)}
                style={{ background: 'transparent', border: 'none', color: '#2B6996', fontSize: 12, fontWeight: 700, cursor: 'pointer', padding: 0, marginTop: 6 }}
              >
                👥 {ev.participant_count} peserta {expandedId === ev.id ? '▲' : '▼'}
              </button>
              {expandedId === ev.id && (
                <div style={{ marginTop: 8, padding: '10px 14px', background: '#12151A', borderRadius: 6 }}>
                  {ev.participant_names.length === 0 ? (
                    <p style={{ color: '#5a616e', fontSize: 12 }}>Belum ada peserta.</p>
                  ) : (
                    <p style={{ color: '#c8ccd3', fontSize: 12, lineHeight: 1.8 }}>{ev.participant_names.join(', ')}</p>
                  )}
                </div>
              )}
              {ev.status === 'selesai' && (
                <button
                  onClick={() => setPreviewRecap(ev.id)}
                  style={{ display: 'inline-block', marginTop: 10, background: 'transparent', border: 'none', color: '#2B6996', fontSize: 12, fontWeight: 700, cursor: 'pointer', padding: 0 }}
                >
                  → Lihat Kartu Rekap
                </button>
              )}
              {ev.status === 'selesai' && (
                <a
                  href={`https://ridewithblast.com/api/recap/${ev.id}/pdf`}
                  style={{ display: 'inline-block', marginTop: 10, marginLeft: 16, color: '#8B92A0', fontSize: 12, fontWeight: 700, textDecoration: 'none' }}
                >
                  → Unduh PDF Rekap
                </a>
              )}
              {ev.status === 'ongoing' && (
                <a
                  href="/live-touring"
                  style={{ display: 'inline-block', marginTop: 10, color: '#D02127', fontSize: 12, fontWeight: 700, textDecoration: 'none' }}
                >
                  → Lihat Live
                </a>
              )}
            </div>
          ))}
        </div>
      )}
      {previewRecap && (
        <div
          onClick={() => setPreviewRecap(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 100,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20,
          }}
        >
          <img
            src={`https://ridewithblast.com/api/recap/${previewRecap}/card`}
            alt=""
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '100%', maxHeight: '75vh', borderRadius: 8, objectFit: 'contain' }}
          />
          <div style={{ display: 'flex', gap: 12, marginTop: 20 }} onClick={(e) => e.stopPropagation()}>
            <a
              href={`https://ridewithblast.com/api/recap/${previewRecap}/card`}
              download
              style={{ background: '#D02127', color: '#fff', padding: '10px 22px', borderRadius: 6, fontSize: 14, fontWeight: 700, textDecoration: 'none' }}
            >
              ⬇ Unduh
            </a>
            <button
              onClick={() => setPreviewRecap(null)}
              style={{ background: 'transparent', border: '1px solid #262b33', color: '#F0EDE4', padding: '10px 22px', borderRadius: 6, fontSize: 14, cursor: 'pointer' }}
            >
              Tutup
            </button>
          </div>
        </div>
      )}
    </Layout>
  );
}
